import {useState, createContext} from 'react';

export const DataContext = createContext({
  departments: [],
  lessDepartmentData: [],
  designations: [],
  contractTypes: [],
  leaveTypes: [],
  locations: [],
  lessLocationsData: [],
  shifts: [],
  essShifts: [],
  roles: [],
  countries: [],
  branches: [],
  users: {list: [], meta: {}},
  genderOptions: [],
  maritalStatusOptions: [],
  essMaritalStatusOptions: [],
  bloodGroupOptions: [],
  essBloodGroupOptions: [],
  disablityOptions: [],
  essDisablityOptions: [],
  states: [],
  essStates: [],
  regions: [],
  umsRegions: [],
  cities: {},
  nationalities: [],
  subDepartments: [],
  essSubDepartments: [],
  essCities: {},
  employeeStatusList: [],
  recruitmentSources: [],
  languages: [],
  essLanguages: [],
  bankCodeOptions: [],
  essBankCodeOptions: [],
  umsBillingTypes: [],
  timeZones: [],
  amstimeZones: [],
  fetchDepartments: () => {
    console.error('fetchDepartments : Not updated?');
  },
  fetchLessDepartmentsInfo: () => {
    console.error('fetchLessDepartmentsInfo: Not updated?');
  },
  fetchDesignations: () => {
    console.error('fetchDesignations : Not updated?');
  },
  fetchContractTypes: () => {
    console.error('fetchContractTypes : Not updated?');
  },
  fetchLocations: () => {
    console.error('fetchLocations : Not updated?');
  },
  fetchLessLocationsInfo: () => {
    /*eslint-disable-next-line no-console*/
    console.log('fetchLessLocationsInfo: Not updated?');
  },
  fetchShifts: () => {
    console.error('fetchShifts : Not updated?');
  },
  fetchEssShifts: () => {
    console.error('fetchEssShifts : Not updated?');
  },
  fetchRoles: () => {
    console.error('fetchRoles : Not updated?');
  },
  fetchCountries: () => {
    console.error('fetchCountries: Not updated?');
  },
  fetchAmsTimeZones: () => {
    console.error('fetchAmsTimeZones: Not updated?');
  },
  fetchBranches: () => {
    console.error('fetchBranches: Not updated?');
  },
  fetchUsers: () => {
    console.error('fetchUsers: Not updated?');
  },
  fetchStates: /** @param {string} [countryId] */ (countryId) => {
    console.error('fetchStates: Not updated?');
  },
  fetchEssStates: /** @param {string} [countryId] */ (countryId) => {
    console.error('fetchStates: Not updated?');
  },
  /** @param {string} [stateId] */
  fetchCities: ({stateId}) => {
    console.error('fetchCities: state: ' + stateId + '; Not updated?');
  },
  // fetchEmployeeStatuses: () => {
  //   console.error('fetchEmployeeStatuses: Not updated?');
  // },
  fetchRecruitmentSources: () => {
    console.error('fetchRecruitmentSources: Not updated?');
  },
  fetchEssCities: ({stateId, countryId}) => {
    console.error('fetchCities: state: ' + stateId + '; Not updated?');
  },
  fetchRegions: () => {
    console.error('fetchRegions: Not updated');
  },
  fetchUmsRegions: () => {
    console.error('fetchUmsRegions: Not updated');
  },
  fetchLanguages: () => {
    console.error('fetchLanguages: Not updated?');
  },
  fetchEssLanguages: () => {},
  fetchBankCodeOptions: () => {
    console.error('fetchBankCode options not updated?');
  },
  fetchEssBankCodeOptions: () => {
    console.error('fetchBankCode options not updated?');
  },
  fetchUmsBillingTypes: () => {
    console.error('fetchBankCode options not updated?');
  },
  hasAccess: (segments) => {
    return false;
  },
  showSideMenuInDevice: false,
  setShowSideMenuInDevice: (active) => {},
});

/**
 * hrms - applications
 */

export function DataContextProvider(props) {
  const [showSideMenuInDevice, setShowSideMenuInDevice] = useState(false);

  return (
    <DataContext.Provider
      value={{
        setShowSideMenuInDevice,
        showSideMenuInDevice,
      }}
    >
      {props.children}
    </DataContext.Provider>
  );
}
